<template>
  <div>
    <div class="file" @click="lookFile">
      <img class="file-icon" src="https://peelprod.oss-cn-shenzhen.aliyuncs.com/biz/173026022759281382.png" />
      <div class="file-name">照片</div>
    </div>
    <Mdialog
      title="查看照片"
      :visible.sync="fileDialog"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="fileDialog = false"
    >
      <Photo :imgArr="imgArr" />
    </Mdialog>
  </div>
</template>

<script>
import Mdialog from '@/components/Mdialog'
import Photo from '@/components/photo.vue'
export default {
  name: 'CheckImg',
  components: {
    Photo,
    Mdialog,
  },
  props: {
    imgArr: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      fileDialog: false,
    }
  },
  mounted() {},
  methods: {
    lookFile() {
      this.fileDialog = true
    },
  },
}
</script>

<style scoped lang="less">
.file {
  display: inline-block;
  cursor: pointer;
  &-icon {
    width: 100px;
    height: 100px;
  }
  &-name {
    font-size: 16px;
    text-align: center;
  }
}
</style>
